export enum UserRole {
    ADMIN = "ADMIN",
    NONE = ""
};